import styled, { createGlobalStyle } from "styled-components";
import { DatePicker } from "antd";

export const DatePickerDropdownStyles = createGlobalStyle`
  .ant-picker-dropdown {
    .ant-picker-panel-container {
      .ant-picker-panel-layout {
        .ant-picker-panel {

          /* ===== Selected Cell Style ===== */
          .ant-picker-cell.ant-picker-cell-selected {
            .ant-picker-cell-inner {
              background-color: #0C53BB;
              color: white;
              border-radius: 2px;
            }
          }

          .ant-picker-cell.ant-picker-cell-today {
            .ant-picker-cell-inner::before {
              border-radius: 2px;
              border-color: #0C53BB;
            }
          }

          /* ===== Header Style ===== */
          .ant-picker-header {
            .ant-picker-header-view {
              color: #1B2028;
              font-family: "Manrope", sans-serif;
              font-weight: 500;
              font-size: 14px;
            }
          }

          /* ===== Body Styles ===== */
          .ant-picker-body {
            .ant-picker-content {
              thead tr th {
                color: #5A6C87;
                font-family: "Manrope", sans-serif;
                font-weight: 500;
                font-size: 14px;
              }
            }

            /* Disabled Cell Styles */
            .ant-picker-cell.ant-picker-cell-disabled {
              color: lightgray;
              background: none;
            }

            .ant-picker-cell.ant-picker-cell-disabled::before {
              color: gray;
              background: none;
            }
          }

        }
      }
        .ant-picker-footer {
          .ant-picker-ranges {
            .ant-picker-now {
              .ant-picker-now-btn {
              color: #0C53BB;
              font-size: 14px;
              font-weight: 600;
              font-family: 'Manrope', sans-serif;

              }
            }
          }
        }
    }
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  font-size: 13px;
  color: black;
  width: 50%;
  border-radius: 6px;
  height: 40px;
  padding: 6px 10px;
  cursor: pointer;

  .ant-picker-input > input::placeholder {
    font-size: 13px;
    opacity: 1;
    color: #5A6C87;
  }

  &:hover {
    border-color: #0C53BB !important;
  }
  &.ant-picker-focused {
    border-color: #0C53BB !important;
    box-shadow: 0px 0px 0px 2px rgba(12, 83, 187, 0.2);
  }
`;
